/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_AnalyzeInputs */

const en_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const de_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const fr_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const es_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const it_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const nl_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const pl_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const fi_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const da_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

const sv_negotiation_analyze = /** @type {(inputs: Negotiation_AnalyzeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze`)
};

/**
* | output |
* | --- |
* | "Analyze" |
*
* @param {Negotiation_AnalyzeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_analyze = /** @type {((inputs?: Negotiation_AnalyzeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_AnalyzeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_analyze(inputs)
	if (locale === "fr") return fr_negotiation_analyze(inputs)
	if (locale === "es") return es_negotiation_analyze(inputs)
	if (locale === "it") return it_negotiation_analyze(inputs)
	if (locale === "nl") return nl_negotiation_analyze(inputs)
	if (locale === "pl") return pl_negotiation_analyze(inputs)
	if (locale === "fi") return fi_negotiation_analyze(inputs)
	if (locale === "da") return da_negotiation_analyze(inputs)
	if (locale === "sv") return sv_negotiation_analyze(inputs)
	return en_negotiation_analyze(inputs)
});